import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

export const queryKeys = {
  snapshot: ["snapshot"] as const,
  meta: ["meta"] as const,
  llama: ["llama-status"] as const,
  health: ["api-health"] as const,
  guide: ["guide"] as const,
  skillGraph: ["skill-graph"] as const,
  gaps: ["gaps"] as const,
  optimizations: ["optimizations"] as const,
  skillBody: (name: string) => ["skill-body", name] as const,
  actionStatus: (runId: number) => ["action-status", runId] as const,
};

export function invalidateAllData() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.snapshot });
}